"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.KiotaGeneratePluginError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../common/localizeUtils");
class KiotaGeneratePluginError extends teamsfx_api_1.SystemError {
    constructor(errorMsg) {
        super({
            source: "kiota",
            message: (0, localizeUtils_1.getDefaultString)("error.kiota.KiotaGeneratePluginError", errorMsg),
            displayMessage: (0, localizeUtils_1.getLocalizedString)("error.kiota.KiotaGeneratePluginError", errorMsg),
        });
    }
}
exports.KiotaGeneratePluginError = KiotaGeneratePluginError;
//# sourceMappingURL=kiota.js.map